import { useMemo } from "react";
import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";

export const useIsPaymentElementRequired = () => {
  const { paywall, getSelectedPrice, previewMutation } =
    usePaywallCheckoutContext();

  const selectedPrice = getSelectedPrice();
  const preview = previewMutation.data;

  return useMemo(
    () =>
      (!selectedPrice.trial_enabled ||
        selectedPrice.trial_requires_upfront_payment ||
        paywall.trial_requires_card) &&
      !preview?.free_forever,
    [paywall, selectedPrice, preview],
  );
};
